import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LABEL_TEMPLATE_TYPES} from '../../dynamic-form/constants/ItemsTypes';
import {InterpolateService} from '../../services/interpolate.service';

@Component({
  selector: 'gen-form-item-label',
  templateUrl: './form-item-label.component.html',
  styleUrls: ['./form-item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormItemLabelComponent implements OnInit {
  @Input() prefix: string;
  @Input() formData: any;
  @Input() labelConfig: any;
  @Input() templateType: LABEL_TEMPLATE_TYPES;
  @Input() payload: any = [] || { };
  @Output() linkClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(private interpolateService: InterpolateService) { }

  ngOnInit() {
    if (Array.isArray(this.payload)) {
      for (let i = 0; i < this.payload.length; i++) {
        this.payload[i]['address'] = this.getParameterizedLink(this.payload[i].linkTemplate);
      }
    }
  }

  updateLink(index) {
    // Links are updated when user clicks on the link
    const link: string = '';
    const linkObj = { template: this.payload[index].linkTemplate, linkText: this.payload[index].text, updatedLink: ''};
    this.linkClick.emit(linkObj);
    if (linkObj.updatedLink != '') { // allow user to update the link
      this.payload[index].address = linkObj.updatedLink;
    }
    else {
      this.payload[index].address = this.getParameterizedLink(this.payload[index].linkTemplate);
    }
  }

  getParameterizedLink(linkTemplate: string): string {
    const str = this.interpolateService.interpolate(linkTemplate, this.formData, true, { useEmptyValues: false, usePartialPath: true});
    return str.trim();
  }
}
